export default __webpack_public_path__ + "static/media/communityIcon.773bd866.jpg";